var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-popup',{attrs:{"closeable":"","close-icon":"close"},on:{"close":_vm.close},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('div',[_c('img',{staticClass:"img",attrs:{"src":"https://imgs.85804669.com/xiaoniao/jicai/popularize/holiday/20250122.jpg"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }